import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
export const KnowledgeArticleEmbeddingRequestedEventSchema = z.object({
    type: z.literal('knowledge_article.embedding.requested'),
    ...baseEventFields,
    articleId: uuidSchema,
});
//# sourceMappingURL=knowledge-base.js.map